angular.module('tgaAdmin').directive('stPersist', [
  'localStorageService',
  function (localStorageService) {
    return {
      require: '^stTable',
      link(scope, element, attr, ctrl) {
        const nameSpace = attr.stPersist;

        // save the table state every time it changes
        scope.$watch(() => ctrl.tableState(), (newValue, oldValue) => {
          if (newValue.pagination.start2) {
            if (newValue.pagination.start2 < newValue.pagination.totalItemCount) {
              // consume start2
              newValue.pagination.start = newValue.pagination.start2;
              newValue.pagination.start2 = undefined;
              ctrl.pipe();
            }
          }
          // after deleting the last remaining game on a page, change the start number to new last page
          if (newValue.pagination.totalItemCount < oldValue.pagination.totalItemCount
            && newValue.pagination.totalItemCount === newValue.pagination.start) {
            newValue.pagination.start -= newValue.pagination.number;
            ctrl.pipe();
          }

          if (newValue !== oldValue) {
            localStorageService.set(nameSpace, newValue);
          }
        }, true);

        // fetch the table state when the directive is loaded
        if (localStorageService.get(nameSpace)) {
          const savedState = localStorageService.get(nameSpace);
          const tableState = ctrl.tableState();

          // create scope object to expose search values
          if (angular.isUndefined(scope[nameSpace])) {
            scope[nameSpace] = {};
          }

          if (savedState.search.predicateObject) {
            Object.keys(savedState.search.predicateObject).forEach((propertyName) => {
              const { predicateObject } = savedState.search;
              if (Object.prototype.hasOwnProperty.call(predicateObject, propertyName)) {
                scope[nameSpace][propertyName] = savedState.search.predicateObject[propertyName] || null;
              }
            });
          }

          angular.extend(tableState, savedState);
          tableState.pagination.start2 = tableState.pagination.start;
          scope.$broadcast('stPersistLoaded');
          ctrl.pipe();
        }
      },
    };
  },
]);
